module.exports = __webpack_public_path__ + "static/media/CompanyValuesIcon.3656f7a2.svg";